export const routes = {
  home: '/',
  corporateEvents: '/corporate-events',
  about: '/about',
  privacyPolicy: '/privacy-policy',
  admin: '/adminboraorkun',
  influencer: '/influencer-registration',
};

export const getRoute = (routeKey) => routes[routeKey] || '/';
